import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';

@Component({
  selector: 'ms-cms-card',
  templateUrl: './CMS-card.component.html',
  styleUrls: ['./CMS-card.component.scss']
})
export class CMSCardComponent implements OnInit { public cmsObj: CmsObject[];
  language: string;
  public title:string;
  public content:string;
  public buttontext:string;

  constructor(private router: Router, private workFlow: WorkFlowService, public cmsService: CmsService) { }

  async ngOnInit() {

  }


  async getCmsObj() {
    
}

public navigate(){
  this.router.navigate(["/cms-editor/home"]);
}
}
